import { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import ReactQuill from 'react-quill';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import CustomToolbar from '../CustomToolbar';
import BlogRowEdition from './BlogRowEdition';
import BlockDialog from '../Content/BlockDialog';
import BlogCategory from '../Category/BlogCategory';
import QuillEditDialog from '../Content/QuillEditDialog';
import BasicDateTimePicker from '../Content/BlogDatePicker';

import { uiLoading2 } from '../../../../actions/ui';
import { basicMsg, msg } from '../../../../actions/swal_msg';
import { getFilesCount } from '../../../../helpers/blog/blogUpdate';
import { generateURL } from '../../../../helpers/admin/productHelper';
import { blogEditionFormValidator } from '../../../../validators/Blog/BlogSaveValidator';
import {
    blogCategorySelected, getBlogToUpdate,
    setBlogInEdition, updateBlogDB, uploadBlogContentImages
} from '../../../../actions/admin/blog';

import {
    DEFAULT_BLOG_COVER_UPD, BLOG_VIDEO_COVER, formats, modules
} from '../../../../constants/admin/blog_constants';
import { GOOGLE_DRIVE_CDN } from '../../../../constants/constants';

import {
    Box, Container, TextField, Typography,
    Button, Stack, Fab, Grid, Backdrop,
    CircularProgress, IconButton, Divider
} from '@mui/material';
import UndoIcon from '@mui/icons-material/Undo';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';

const BlogUpdate = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loading2 } = useSelector(state => state.ui);
    const { blog: { posts, categories }, blog_data: { blogInEdition } } = useSelector(state => state.blog);
    const { _id, category, imgId, imgUploaded, content } = blogInEdition;

    // url de blog
    const { url } = useParams();

    const [blogModel, setBlogModel] = useState(blogInEdition);
    const { title, author, folderId } = blogModel;

    // imagen de portada
    const [mainImg, setMainImg] = useState(DEFAULT_BLOG_COVER_UPD);
    const { imgSrc, imgFile } = mainImg;
    const fileInputRef = useRef();

    // campo Quill Editor
    const [text, setText] = useState('');

    // contenido en filas/columnas
    const [row, setRow] = useState([]);

    // contador de filas y columnas (para asignar id's)
    const [rowCounter, setRowCounter] = useState(0);
    const [colCounter, setColCounter] = useState(0);

    // mostrar diálogo de edición de bloque
    const [open, setOpen] = useState(false);
    // mostrar diálogo de longitud de bloque
    const [open1, setOpen1] = useState(false);

    // redireccionar
    const [submitted, setSubmitted] = useState(false);

    // archivos a eliminar
    const [oldFiles, setOldFiles] = useState([]);

    useEffect(() => {
        validateContent();
        if (submitted)
            navigate('/nefro-admin/blog');
    }, [posts]);

    // datos de blog actualizables
    useEffect(() => {
        if (blogInEdition._id) {
            // contenido editable
            setBlogModel(blogInEdition);
            setMainImg({
                imgSrc: `${GOOGLE_DRIVE_CDN}${imgId}`,
                imgFile: '',
                imgUploaded
            });
            buildContent();
            dispatch(blogCategorySelected(
                categories.map(e => category.includes(e.category)
                    ? { ...e, checked: true }
                    : { ...e, checked: false }
                )
            ));
        }
    }, [blogInEdition]);

    // validar que blog haya cargado para edición
    const validateContent = () => {
        // no hay blog activo
        if (_id === '') {
            if (posts.length > 0) { // blogs cargados
                const BlogModel = posts.find(e => e.url === url);
                if (BlogModel)
                    dispatch(setBlogInEdition(BlogModel));
                else
                    navigate('/nefro-admin/blog');
            } else // no se encontraron blogs
                dispatch(getBlogToUpdate(url));
        }
    };

    // colocar filas y columnas de contenido
    const buildContent = () => {
        // cantidad total de bloques
        // const total_blocks = content.reduce((acc, r) => acc + (r.col?.length || 0), 0);

        let col_counter = 0;
        setRow(content.map((e, i) => ({
            ...e,
            id: `row-${i}`,
            col: e.col.map((u) => {
                return {
                    ...u,
                    src: '',
                    file: '',
                    id: `col-${col_counter++}`,
                    uploaded: ['img', 'video'].includes(u.type),
                };
            })
        })));

        setRowCounter(content.length);
        setColCounter(col_counter);
    };

    // cambios en campos
    const handleOnChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (name === 'title') {
            if (value.length <= 200)
                setBlogModel({ ...blogModel, [name]: value });
        } else if (name === 'author') {
            if (value.length <= 100)
                setBlogModel({ ...blogModel, [name]: value });
        }
    };

    // subir portada de Blog
    const uploadMainImg = ({ target }) => {
        const file = target.files[0]
        if (['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async (event) => {
                const src = event.target.result;
                setMainImg({
                    ...mainImg,
                    imgSrc: src,
                    imgFile: file
                });
                // se remueve imagen principal
                if (imgUploaded)
                    setOldFiles([...oldFiles, imgId]);
            };
        }
    };

    // cambios en Quill Editor
    const handleChange = (html) => {
        if (html === '<p><br></p>')
            setText('');
        else
            setText(html);
    };

    // restablecer imagen de portada
    const previousMainImg = () => {
        fileInputRef.current.value = '';
        setMainImg({
            imgSrc: `${GOOGLE_DRIVE_CDN}${imgId}`,
            imgFile: '',
            imgUploaded
        });
        if (imgUploaded)
            setOldFiles(oldFiles.filter(e => e !== imgId));
    };

    // guardar bloque
    const addBlock = () => {
        if (text !== '') {
            setOpen1(true);
        } else basicMsg('Ingrese contenido en el recuadro');
    };

    // seleccionar longitud de bloque y guardar
    const insertBlock = (xs, md, row_pos) => () => {
        if (row.length > 0) {
            const NewBlock = {
                item: text,
                src: '',
                file: '',
                type: 'txt',
                xs, md, // vista en navegador (Grid)
                // id debe ser un string por el Draggable
                id: `col-${colCounter}`
            };
            setRow(e_row => {
                return e_row.map((e_col, index) => {
                    if (index === row_pos)
                        return {
                            ...e_col,
                            col: [...e_col.col, NewBlock] 
                        };
                    return e_col;
                });
            });
            setColCounter(colCounter + 1);
            setOpen1(false);
            // limpiar campo de Quill
            setText('');
        }
    };

    // limpiar contenido de Quill
    const cleanBlock = () => {
        if (text !== '')
            Swal.fire({
                title: 'Limpiar el contenido del bloque',
                showDenyButton: true,
                confirmButtonText: 'Si',
                denyButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed)
                    setText('');
            });
    };

    // agregar fila de contenido
    const addRow = () => {
        setRow([...row, { col: [], id: `row-${rowCounter}` }]);
        setRowCounter(rowCounter + 1);
    };

    // subir imagen/video a contenido de blog
    const uploadFiles = async ({ target }) => {
        const promise = await loadFiles(target.files);
        if (promise) {
            const { columns, counter } = promise;
            let content = [...row];
            content[0].col.push(...columns);
            setRow(content);
            setColCounter(counter);
        }
    };

    // cargar archivos mediante Promesa
    const loadFiles = async (files) => {
        let counter = colCounter;
        const filePromise = [...files].map((file, i) => {
            return new Promise((resolve, reject) => {
                if (['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = async (event) => {
                        const src = event.target.result;
                        const item = `<img class="img-fluid" src="${src}" alt="imagen-blog-Nefropolis">`;
                        resolve({
                            item,
                            src,
                            file,
                            type: 'img',
                            xs: 12,
                            md: 6,
                            id: `col-${counter}`,
                            uploaded: false
                        });
                        counter++;
                    };
                } else if (file.type === 'video/mp4') {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = (event) => {
                        const src = event.target.result;
                        const item = `<div><h6>Video: ${file.name}</h6><img style="height: 200px; display:block; margin: auto;" src=${BLOG_VIDEO_COVER} alt="video-blog-Nefropolis"></div>`;
                        resolve({
                            item,
                            src,
                            file,
                            type: 'video',
                            xs: 12,
                            md: 6,
                            id: `col-${counter}`,
                            uploaded: false
                        });
                        counter++;
                    };
                }
            });
        });
        return {
            columns: await Promise.all(filePromise),
            counter
        }
    };

    const updateBlog = () => {
        const SelectedCategories = categories.filter(e => e.checked).map(u => u.category);
        if (blogEditionFormValidator({ ...blogModel, categories: SelectedCategories, row })) {
            Swal.fire({
                title: '¿Actualizar el blog?',
                showDenyButton: true,
                confirmButtonText: 'Si',
                denyButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const rowContent = row.filter((e, i) => e.col.length > 0);
                    const { files, filesCount } = getFilesCount(rowContent, imgFile);

                    let i = 0; // contador de filas
                    let contentModel = []; // contenido dinámico hacia BD
                    const url = generateURL(title);

                    if (filesCount > 0) {
                        dispatch(uiLoading2(true));
                        const data = new FormData();
                        data.append('folderId', folderId);
                        for (const e of files) {
                            data.append('file', e);
                        };
                        const req = await uploadBlogContentImages(data, 'update');
                        if (req.status) {
                            const { imagesId } = req.resp;

                            if (filesCount === imagesId.length) {
                                let j = 0; // contador de archivos

                                // imagen principal
                                const newMainImg = imgFile !== '' ? imagesId[0] : imgId;
                                // arreglo de id's de archivos
                                const images = imgFile !== '' ?
                                    imagesId.length > 1 ? imagesId.filter((e, i) => i !== 0) : []
                                    : imagesId;

                                for (const e of rowContent) {
                                    contentModel = [...contentModel, {
                                        col: []
                                    }];
                                    for (const col of e.col) {
                                        const { item, type, xs, md, fileId } = col;
                                        if (col.type === 'img' && !col.uploaded) {
                                            contentModel[i].col = [...contentModel[i].col, {
                                                item: `<img class="img-fluid" src="${GOOGLE_DRIVE_CDN}${images[j]}" alt="imagen-blog-Nefropolis">`,
                                                type, xs, md,
                                                fileId: images[j]
                                            }];
                                            j++;
                                        } else if (col.type === 'video' && !col.uploaded) {
                                            contentModel[i].col = [...contentModel[i].col, {
                                                item: `<iframe src="https://drive.google.com/file/d/${images[j]}/preview" title="video-blog-Nefropolis" width="100%" height="100%"></iframe>`,
                                                type, xs, md,
                                                fileId: images[j]
                                            }];
                                            j++;
                                        } else
                                            contentModel[i].col = [...contentModel[i].col, {
                                                item, type, xs, md, fileId
                                            }];
                                    }
                                    i++;
                                }
                                setSubmitted(true);
                                dispatch(updateBlogDB({
                                    ...blogModel,
                                    url,
                                    category: SelectedCategories,
                                    content: contentModel,
                                    folderId,
                                    imgId: newMainImg,
                                    imgUploaded: imgFile !== '' ? true : imgUploaded
                                }, oldFiles, navigate));
                            } else {
                                msg('warning', 'Blog',
                                    'No se han subido todas las imágenes');
                                for (const e of rowContent) {
                                    contentModel = [...contentModel, {
                                        col: []
                                    }];
                                    for (const col of e.col) {
                                        const { item, type, xs, md, fileId } = col;
                                        if (col.type !== 'img' && col.type !== 'video')
                                            contentModel[i].col = [...contentModel[i].col, {
                                                item, type, xs, md, fileId
                                            }];
                                    };
                                    i++;
                                }
                                setSubmitted(true);
                                dispatch(updateBlogDB({
                                    ...blogModel,
                                    url,
                                    category: SelectedCategories,
                                    content: contentModel,
                                    folderId,
                                    imgId,
                                    imgUploaded
                                }, oldFiles, navigate));
                            }
                        }
                    } else {
                        for (const e of rowContent) {
                            contentModel = [...contentModel, {
                                col: []
                            }];
                            for (const col of e.col) {
                                const { item, type, xs, md, fileId } = col;
                                contentModel[i].col = [...contentModel[i].col, {
                                    item, type, xs, md, fileId
                                }];
                            };
                            i++;
                        };
                        setSubmitted(true);
                        dispatch(updateBlogDB({
                            ...blogModel,
                            url,
                            category: SelectedCategories,
                            content: contentModel,
                            folderId,
                            imgId,
                            imgUploaded
                        }, oldFiles, navigate));
                    }
                }
            });
        }
    };

    return (
        <Container maxWidth="xl" sx={{ mb: 5, mt: '90px' }}>
            <Box display='flex' justifyContent='flex-start' gap='12px' flexWrap='wrap' mb={2}>
                <IconButton aria-label="go-back" sx={{ my: 'auto' }}
                    onClick={() => navigate('/nefro-admin/blog')}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant='h5' paragraph sx={{ my: 'auto' }}>
                    Actualizar blog
                </Typography>
            </Box>
            <Grid container spacing={4}>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Box sx={{ p: 2 }}>
                        <TextField fullWidth
                            variant='outlined'
                            label="Título del blog"
                            size='small'
                            name='title'
                            inputProps={{ maxLength: 200 }}
                            value={title}
                            onChange={handleOnChange}
                        />
                        <TextField fullWidth
                            variant='outlined'
                            label="Autor del blog"
                            size='small'
                            name='author'
                            inputProps={{ maxLength: 100 }}
                            value={author}
                            onChange={handleOnChange}
                            sx={{ my: 2 }}
                        />
                        <BasicDateTimePicker
                            values={blogModel}
                            setValues={setBlogModel}
                        />
                        <Divider textAlign="left" sx={{ my: 2.5, fontWeight: '600' }}>
                            CATEGORIAS
                        </Divider>
                        <BlogCategory />
                    </Box>
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Box sx={{ p: 2, boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)' }}>
                        <Typography variant='h6' paragraph sx={{ fontWeight: '600' }}>Imagen de portada</Typography>
                        <Box sx={{ textAlign: 'center', mb: 3 }}>
                            <Box sx={{ mb: 2 }}>
                                <img src={imgSrc} alt='portada-blog' width='300' height='300' style={{ objectFit: 'contain', borderRadius: '4px' }} />
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                <Button variant="contained" startIcon={<InsertPhotoIcon />} component="label">
                                    <input hidden accept="image/*" ref={fileInputRef}
                                        type="file" onChange={uploadMainImg}
                                    />
                                    Imagen de portada
                                </Button>
                                {
                                    imgFile !== '' &&
                                    <Button variant="text" startIcon={<UndoIcon />} sx={{textTransform: 'none'}}
                                        onClick={previousMainImg}>
                                        Restablecer imagen
                                    </Button>
                                }
                            </Box>
                        </Box>
                        {/* <Grid item xs={12} md={4}>
                            <img src={imgSrc} alt='portada-blog'
                                className='img-fluid' />
                        </Grid> */}
                        {/* <Grid item xs={12} md={6}>
                            <Stack direction="column"
                                justifyContent="center"
                                alignItems="flex-start"
                                spacing={2}>
                                <Button variant="outlined" startIcon={<InsertPhotoIcon />} component="label">
                                    <input hidden accept="image/*"
                                        type="file" onChange={uploadMainImg}
                                    />
                                    Imagen de portada
                                </Button>
                                {
                                    imgFile !== '' &&
                                    <Button variant="contained" startIcon={<UndoIcon />}
                                        onClick={previousMainImg}>
                                        Restablecer imagen
                                    </Button>
                                }
                            </Stack>
                        </Grid> */}
                    </Box>
                </Grid>
            </Grid>
            {/* <TextField fullWidth
                variant='outlined'
                label="Título del blog"
                size='small'
                name='title'
                inputProps={{ maxLength: 200 }}
                value={title}
                onChange={handleOnChange}
            />
            <TextField fullWidth
                variant='outlined'
                label="Autor del blog"
                size='small'
                name='author'
                inputProps={{ maxLength: 100 }}
                value={author}
                onChange={handleOnChange}
                sx={{ my: 2 }}
            />
            <BasicDateTimePicker
                values={blogModel}
                setValues={setBlogModel}
            /> */}

            {/* <Grid container spacing={1} my={2}>
                <Grid item xs={12} md={4}>
                    <img src={imgSrc} alt='portada-blog'
                        className='img-fluid' />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Stack direction="column"
                        justifyContent="center"
                        alignItems="flex-start"
                        spacing={2}>
                        <Button variant="outlined" startIcon={<InsertPhotoIcon />} component="label">
                            <input hidden accept="image/*"
                                type="file" onChange={uploadMainImg}
                            />
                            Imagen de portada
                        </Button>
                        {
                            imgFile !== '' &&
                            <Button variant="contained" startIcon={<UndoIcon />}
                                onClick={previousMainImg}>
                                Restablecer imagen
                            </Button>
                        }
                    </Stack>
                </Grid>
            </Grid> */}

            <Box sx={{ mt: 3 }}>
                <CustomToolbar />
                <ReactQuill
                    value={text}
                    name='quill'
                    onChange={handleChange}
                    modules={modules}
                    formats={formats}
                />
            </Box>

            <Stack direction="row" spacing={2} sx={{ mt: 2, mb: 5 }}>
                <Button variant="contained"
                    onClick={addBlock}>
                    Guardar
                </Button>
                <Button onClick={cleanBlock}>
                    Limpiar
                </Button>
                <Button variant="outlined" startIcon={<InsertPhotoIcon />} component="label">
                    <input hidden accept="image/*, video/*"
                        type="file" onChange={uploadFiles}
                        multiple="multiple" />
                    Agregar imagen/video
                </Button>
            </Stack>

            {/* <Box sx={{ mt: 3 }}>
                <Typography variant='body1'>Preview en HTML</Typography>
                <textarea defaultValue={text} rows={5} style={{ width: '100%' }} disabled></textarea>
            </Box>

            <BlogCategory /> */}

            <BlogRowEdition setOpen={setOpen}
                row={row}
                setRow={setRow}
                oldFiles={oldFiles}
                setOldFiles={setOldFiles}
            />

            <Button variant='contained'
                onClick={addRow}>
                Agregar fila
            </Button>

            <QuillEditDialog 
                open={open}
                setOpen={setOpen}
                row={row}
                setRow={setRow}
            />

            <BlockDialog
                open={open1}
                setOpen={setOpen1}
                rowLength={row.length}
                insertBlock={insertBlock}
            />

            <Fab color="primary"
                aria-label="add" sx={{
                    position: "fixed",
                    bottom: (theme) => theme.spacing(2),
                    right: (theme) => theme.spacing(2)
                }}
                disabled={loading2}
                onClick={updateBlog}>
                <SaveAsIcon />
            </Fab>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading2}>
                <CircularProgress />
            </Backdrop>
        </Container>
    );
};

export default BlogUpdate;